const toastTrigger = document.querySelectorAll(".liveToastBtn");
const toastLiveExample = document.getElementById("liveToast");
if (toastTrigger) {
    toastTrigger.forEach(function (button) {
        button.addEventListener("click", function () {
            var toast = new bootstrap.Toast(toastLiveExample);
            toast.show();
        });
    });
}